module.exports = __webpack_public_path__ + "static/img/dy_krgy.5ff440f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dy_krgy.png
// module id = a+Hw
// module chunks = 130